"use client";

import React from "react";
import "./PromosSection.scss";
import Link from "next/link";

const GenericElements = ({
  heading,
  description,
  buttonText,
  buttonLink,

  noBottomPadding = false,
}) => {
  return (
    <div
      className="generic-content-section"
      style={{marginPadding: noBottomPadding ? 0 : "unset" }}
    >
      <div className="container h-100 d-flex flex-column justify-content-center">
        <div className="row h-100 px-4">
          <div className="col-12 d-flex flex-column align-items-center text-center justify-content-center py-2">
            {heading && (
              <h3 className="generic-content-heading mb-0">
                {heading}
                <span className="dash-left"></span>
                <span className="dash-right"></span>
              </h3>
            )}
            {description && (
              <p className="generic-content-description mt-3 mb-3">
                {description}
              </p>
            )}
            {buttonText && buttonLink && (
              <Link href={buttonLink}>
                <button className="generic-content-button mt-4">
                  {buttonText}
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenericElements;
